import React from "react";
import PropTypes from "prop-types";

const Header = ({ header }) => {
  return (
    <div className="gen-hdf-header">
      <div
        dangerouslySetInnerHTML={{
          // eslint-disable-next-line xss/no-mixed-html
          __html: header,
        }}
      />
    </div>
  );
};

Header.propTypes = {
  header: PropTypes.string.isRequired,
};

export default Header;



// WEBPACK FOOTER //
// ./components/employee/gen-hdf-form/Header.js